// 2020-06-27export { TropaMovimientoListComponent } from './tropa-movimiento-list.component';